// extracted by mini-css-extract-plugin
export default {"text-field":"FilterDishBar_text-field__pU-N0","btn-panel":"FilterDishBar_btn-panel__0leVi"};